import { SpaEntityType } from 'shared-types/Spa';
import { resolveSpaMaxGuests } from './resolveSpaMaxGuests';

export const resolveSpaGuestBounds = (
  entity: Pick<SpaEntityType, 'minimumGuests' | 'maximumGuests'>,
  { slotCapacity, requestedGuests }: { slotCapacity?: number; requestedGuests?: number } = {}
): { min: number; max: number } => {
  const min = entity.minimumGuests || 1;
  const max = Math.max(
    min,
    resolveSpaMaxGuests(entity, { slotCapacity, requestedGuests: requestedGuests || 1 })
  );
  return { min, max };
};
